import { Calendar } from "primereact/calendar";
import React, { useState } from "react";

const BoardData = ({ item, handleDragStart, columnId, isSubtask = false }) => {
  const [activeSubtask, setActiveSubtask] = useState(false);
  const { id, title, dueDate, description, sub_tasks } = item;

  return (
    <>
      <div className="board" draggable={!isSubtask} onDragStart={() => handleDragStart(columnId, item)}>
        <h5>{title}</h5>

        <div className="board-btns-group">
          <span className="board-btns">
            <i className="ri-user-add-line"></i>
          </span>
          <span className="board-btns">
            <Calendar className="task-table-calendar" value={dueDate} dateFormat="M dd" showButtonBar showIcon />
          </span>
        </div>

        <div className="board-hover-btn-group">
          <button type="button">
            <i className="ri-check-line"></i>
          </button>
          <button type="button">
            <i className="ri-add-circle-line"></i>
          </button>
          <button type="button">
            <i className="ri-more-fill"></i>
          </button>
        </div>

        {sub_tasks?.length > 0 && (
          <button type="button" className="board-subtask-link" onClick={() => setActiveSubtask(!activeSubtask)}>
            <i className="ri-git-merge-line"></i> &nbsp;{sub_tasks.length} Subtasks
          </button>
        )}
      </div>

      {activeSubtask && sub_tasks?.length > 0 && (
        <div className="board-sub">
          {sub_tasks.map((subtask) => (
            <BoardData key={subtask.id} item={subtask} handleDragStart={handleDragStart} columnId={columnId} isSubtask={true} />
          ))}
        </div>
      )}
    </>
  );
};

export default BoardData;
